import React, { useId, useState } from 'react';
import { storageEnabled, validateAttachments } from '../lib/submitRequest';

export default function AttachmentField() {
  const id = useId();
  const [error, setError] = useState('');
  if (!storageEnabled) return null;
  return <div className="md:col-span-2 my-4">
    <label htmlFor={id} className="block text-sm font-semibold text-mce-navy">Pièces jointes (facultatif)</label>
    <p id={`${id}-help`} className="text-xs text-slate-600 my-2">CV, présentation ou cahier des charges : 3 fichiers maximum, 5 Mo chacun. PDF, DOCX, JPG ou PNG.</p>
    <input id={id} name="attachments" type="file" multiple accept=".pdf,.docx,.jpg,.jpeg,.png" aria-describedby={`${id}-help`} className="block w-full text-sm text-slate-700" onChange={event => {
      try { validateAttachments(Array.from(event.target.files)); setError(''); }
      catch (failure) { setError(failure.message); event.target.value = ''; }
    }} />
    {error && <p role="alert" className="text-sm text-red-700 mt-2">{error}</p>}
  </div>;
}
